<template>
  <div class="fit-notes">
    <div
      v-if="productFitGraphic"
      class="fit-notes__graphic text-body-2xs-regular"
    >
      <div
        v-if="productFitGraphic.overallFit"
        v-text="productFitGraphic.overallFit"
      />
      <div
        v-if="productFitGraphic.scale > 0 && productFitGraphic.scale < 6"
        class="fit-notes__graphic__diagram"
        :class="`fit-notes__graphic__diagram--${productFitGraphic.scale}`"
      />
      <div class="fit-notes__graphic__labels">
        <span
          v-if="productFitGraphic.low"
          class="fit-notes__graphic__low"
          v-text="productFitGraphic.low"
        />
        <span
          v-if="productFitGraphic.middle"
          class="fit-notes__graphic__middle"
          v-text="productFitGraphic.middle"
        />
        <span
          v-if="productFitGraphic.high"
          class="fit-notes__graphic__high"
          v-text="productFitGraphic.high"
        />
      </div>
    </div>

    <div
      v-if="productFitNotes"
      class="fit-notes__copy rte"
      v-html="productFitNotes"
    />
  </div>
</template>

<script>

/**
 * Vue: Fit notes (fit-notes)
 * -----------------------------------------------------------------------------
 * Fit notes and fit graphic for a product, from metafield data.
 *
 * @param {String} productFitNotes - Markup
 * @param {String} productFitGraphic - Overall fit graphic data
 *
 */
export default {
  name: 'FitNotes',

  props: {
    productFitNotes: {
      type: String,
      default: '',
    },
    productFitGraphic: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style lang="scss">
@import './fit-notes';
</style>
